var React = require('react');

function FrontendDropdownMenuContacts (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M14 3h-12c-1.1 0-2 0.9-2 2v7c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-7c0-1.1-0.9-2-2-2zM2 12c0-2.209 1.119-4 2.5-4-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5c1.381 0 2.5 1.791 2.5 4h-5zM14 12h-5v-1h5v1zM14 10h-5v-1h5v1zM14 8h-5v-1h5v1z"}));
}

FrontendDropdownMenuContacts.displayName = "FrontendDropdownMenuContacts";

FrontendDropdownMenuContacts.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = FrontendDropdownMenuContacts;

FrontendDropdownMenuContacts.default = FrontendDropdownMenuContacts;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/frontend-dropdown-menu-contacts.svg
// module id = 1007
// module chunks = 0